import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Input from '../../Common/ui/input'
import SearchableSelectInput from '../../Common/ui/SearchableSelectInput'
import { Button } from '../../Common/ui/button'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import DropdownTextInput from '../../Common/ui/DropdownTextInput'
import { useTranslation } from 'react-i18next'
import { useCommonStore } from '../../Common/store/CommonStore'
import { Checkbox } from '../../Common/ui/checkbox'
import MultiSelectInput from '../../Common/ui/MultiSelect'
import DatePickerInput from '../../Common/ui/DatePickerInput'
import { Avatar, IconButton, Tooltip } from '@mui/material'
import { toast } from 'react-toastify'
import { validateAndProcessImage } from '../../../src/lib/utils'
import PhoneNumber from '../../Common/ui/PhoneNumber'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const AddNodeDrawer = ({ nodes, newNode, setnewNode, currentNode, setAddState, addState, onAdd, childNodeCount, loading, setLoading }) => {
    const { t } = useTranslation()
    const { register, handleSubmit, reset, resetField, setValue, formState: { errors, isSubmitting, isLoading }, control, setError, clearErrors } = useForm({ mode: 'onChange' })
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const [ depByOrgId, setDepByOrgId ] = useState([])
    const [ desByOrgId, setDesByOrgId ] = useState([])
    const [ roleData, setRoleData ] = useState([])
    const { getAllRole, rollData, getAllDepartmentByOrgId, departmentByOrgId, getAllDesignationByOrgId, designationByOrgId } = useCommonStore()
    const [ selectedImage, setSelectedImage ] = useState(null)
    const orgId = localStorage.getItem('orgId')
    let fromMaxDate = new Date()
    fromMaxDate.setHours(0, 0, 0, 0)
    fromMaxDate = new Date(fromMaxDate.toISOString())
    const [ resetTrigger, setResetTrigger ] = useState(0)

    const handleImageChange = (e) => {
        const file = e.target.files[0]
        validateAndProcessImage(file, setSelectedImage, setnewNode, t, toast)
        e.target.value = ''
    }
    const handleRemoveImage = () => {
        setSelectedImage(null)
        setnewNode((prevNode) => ({
            ...prevNode,
            profilePic: ''
        }))
    }
    useEffect(() => {
        getAllRole(orgId)
        getAllDepartmentByOrgId(orgId)
        getAllDesignationByOrgId(orgId)
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [addState])

    useEffect(() => {
        if (newNode?.atPresent === true) {
            const newToDate = new Date()
            setnewNode((prevNode) => ({ ...prevNode, toDate: newToDate }))
            setValue('toDate', newToDate)
        } if (newNode?.toDate) {
            resetField(OnboardEntity.AT_PRESENT)
        } if (newNode?.atPresent === true) {
            clearErrors('toDate')
        } if (newNode?.atPresent === false) {
            setnewNode((prevNode) => ({ ...prevNode, toDate: null }))
            setValue('toDate', null)
            resetField(OnboardEntity.TO_DATE)
        }
    }, [newNode?.atPresent])

    useEffect(() => {
        if (departmentByOrgId.length > 0) {
            setDepByOrgId(departmentByOrgId)
        }
        if (designationByOrgId.length > 0) {
            setDesByOrgId(designationByOrgId)
        }
        if (rollData.length > 0) {
            setRoleData(rollData)
        }
    }, [ departmentByOrgId, designationByOrgId, rollData ])

    useEffect(() => {
        if (newNode?.isVacant === undefined) {
            setnewNode((prevNode) => ({ ...prevNode, isVacant: false }))
        }
        if (newNode?.isVacant) {
            if (newNode) {
                reset({
                    designation: newNode?.designation,
                    department: newNode?.department,
                    fromDate: newNode?.fromDate,
                    toDate: newNode?.toDate,
                    role: newNode?.role
                })
            }
            setnewNode((prevNode) => ({
                ...prevNode,
                toDate: new Date(),
                atPresent: true
            }))
            setValue('toDate', new Date())
            resetField(OnboardEntity.AT_PRESENT)
        } else {
            if (newNode) {
                reset({
                    displayName: newNode?.displayName,
                    firstName: newNode?.firstName,
                    lastName: newNode?.lastName,
                    designation: newNode?.designation,
                    level: newNode?.level,
                    department: newNode?.department,
                    emailId: newNode?.emailId,
                    phoneNumber: newNode?.phoneNumber,
                    phoneCode: newNode?.phoneCode,
                    phoneCountryCode: newNode?.phoneCountryCode,
                    role: newNode?.role,
                    fromDate: newNode?.fromDate,
                    toDate: newNode?.toDate
                })
            }
            setnewNode((prevNode) => ({
                ...prevNode,
                atPresent: false
            }))
            setValue('toDate', newNode?.toDate || '')
        }
    }, [newNode?.isVacant])

    const resetAll = () => {
        reset()
        // resetField(OnboardEntity.PHONE_NUMBER)
        // resetField(OnboardEntity.DEPARTMENT_NAME)
        // resetField(OnboardEntity.DESIGNATION_NAME)
        // resetField(OnboardEntity.AT_PRESENT)
    }
    const onSubmit = () => {
        setLoading(true)
        onAdd(currentNode, newNode, childNodeCount, resetAll)

        setSelectedImage(null)
        setResetTrigger((prev) => prev + 1)
    }
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }

        if (!open) {
            reset()
            resetField(OnboardEntity.PHONE_NUMBER)
            setSelectedImage(null)
            setnewNode({})
        }
        if (open) {
            setnewNode({
                ...newNode,
                department: '',
                designation: '',
                departmentId: 0,
                designationId: 0
            })
            resetField(OnboardEntity.DEPARTMENT_NAME)
            resetField(OnboardEntity.DESIGNATION_NAME)
        }
        if (newNode?.isVacant) {
            setnewNode((prevNode) => ({
                ...prevNode,
                toDate: new Date(),
                atPresent: true
            }))
            setValue('toDate', new Date())
        }
        setAddState({ ...addState, [anchor]: open })
    }
    const handleAddFieldsChange = (value, name) => {
        if (name === OnboardEntity.PHONE_NUMBER) {
            if (value) {
                // setnewNode(prevState => ({ ...prevState, [name]: value }))
                setnewNode((newNode) => ({
                    ...newNode,
                    phoneCountryCode: value.countryCode,
                    phoneCode: value.phNumberCode,
                    phoneNumber: value.phNumber
                }
                ))
            }
            return
        //  resetField(OnboardEntity.PHONE_NUMBER)
        }
        if (name === OnboardEntity.FROM_DATE || name === OnboardEntity.TO_DATE || name === OnboardEntity.AT_PRESENT || name === OnboardEntity.IS_VACANT || name === OnboardEntity.ROLE || name === OnboardEntity.FIRST_NAME || name === OnboardEntity.DEPARTMENT_NAME || name === OnboardEntity.DESIGNATION_NAME) {
            setnewNode((newNode) => ({ ...newNode, [name]: value }))
        } else {
            setnewNode({ ...newNode, [name]: value?.target?.value })
        }
    }
    useEffect(() => {
        if (newNode.fromDate && newNode.toDate && new Date(newNode.fromDate) > new Date(newNode.toDate)) {
            setnewNode(prevNode => ({ ...prevNode, fromDate: '' }))
        }
        if (newNode.fromDate === '') {
            resetField('fromDate')
        }
    }, [ newNode.fromDate, newNode.toDate ])

    // const lableComponent = (<div className='w-[100%] h-full pl-[10px] mb-1.5 flex'>
    //     <Checkbox name={'atPresent'} checked={newNode?.atPresent || newNode?.isVacant === true} disabled={newNode?.isVacant === true} onCheckedChange={(e) => handleAddFieldsChange(e, OnboardEntity.AT_PRESENT)} />
    //     <label className='grc-label ml-2'>{t('Till Now')}</label>
    // </ div>)

    const handleCancelClose = () => {
        setAddState({ ...addState, right: false })
        reset()
        resetField(OnboardEntity.PHONE_NUMBER || OnboardEntity.DEPARTMENT_NAME || OnboardEntity.DESIGNATION_NAME)
        setnewNode({})
        setSelectedImage(null)
    }

    const list = (anchor) => (
        <Box role="presentation" sx={{ height: '100%' }}>
            <div className="h-[88%] overflow-auto py-4">
                <div className="flex justify-between items-center pb-3 pr-4 border-b-2">
                    <p className="h-[7%] px-4 pt-[0px] text-h2 flex flex-col justify-center" style={{ color: 'hsl(var(--primary))' }}>{t('Add User')}</p>
                    <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton onClick={() => handleCancelClose()} aria-label="close" disabled={isSubmitting || isLoading || loading}>
                            <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                        </IconButton>
                    </Tooltip>
                </div>
                <div className="h-[14%] flex border-b-2 pb-3 px-4 items-center justify-between">
                    <div className="flex flex-row items-center space-x-4">
                        {newNode?.profilePic
                            ? <div className='w-[50px] h-[50px]'>
                                <img style={{ width: '100%', height: '100%', borderRadius: '50%' }} src={`data:${newNode?.profilePic?.contentType};base64, ${newNode?.profilePic?.file}`} alt="Profile Icon" />
                            </div>
                            : <Avatar sx={{ width: 50, height: 50 }} className='mt-4' alt="Profile" />
                        }
                        <div className='space-x-4 px-2'>
                            <div className='flex mt-4'>
                                <label className={`flex cursor-pointer ${selectedImage ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                    <input type="file" accept="image/png, image/jpeg, image/jpg, image/webp" style={{ display: 'none' }} onChange={handleImageChange} disabled={!!selectedImage} />
                                    <img src={'/Common/Icon/ArrowUploadIcon.svg'} alt="Upload icon" />
                                    <span className='mt-2 ml-2'>{t('Upload')}</span>
                                </label>
                                <div
                                    className={`flex cursor-pointer ml-5 mt-1 ${!selectedImage ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    onClick={selectedImage ? handleRemoveImage : null} >
                                    <img src={'/Common/Icon/DeleteIcon.svg'} alt="Remove icon" />
                                    <span className='mt-1 ml-2'>{t('Remove')}</span>
                                </div>
                            </div>
                            <div className='mt-2 text-[12px]'>{t('Image size should not exceed 2MB')}</div>
                        </div>
                    </div>
                    <div className='w-[20%] h-full flex flex-row justify-center items-center'>
                        <Checkbox name={'isVacant'} checked={newNode?.isVacant} borderColor='hsl(var(--primary))' onCheckedChange={(e) => handleAddFieldsChange(e, 'isVacant')} />
                        <label className='grc-label ml-2'>{t('Vacant')}</label>
                    </ div>
                </div>
                <div className='h-[73%] mt-3'>
                    <div className="grid grid-cols-3 gap-4 px-4">
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <DropdownTextInput errors={errors} control={control} required={!newNode?.isVacant} rules={{ required: newNode?.isVacant ? false : t('First Name is Required') }} name='firstName' label={t('First Name')} placeholder={t('Enter First Name')} value={!newNode?.isVacant ? newNode?.firstName : ''} onValueChange={handleAddFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} name='middleName' label={t('Middle Name')} register={register} placeholder={t('Enter Middle name')} type="text" value={!newNode?.isVacant ? newNode?.middleName : ''} onValueChange={handleAddFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required={!newNode?.isVacant} rules={{ required: newNode?.isVacant ? false : t('Last Name is Required') }} name='lastName' label={t('Last Name')} register={register} placeholder={t('Enter Last name')} type="text" value={!newNode?.isVacant ? newNode?.lastName : ''} onValueChange={handleAddFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required={!newNode?.isVacant} rules={{ required: newNode?.isVacant ? false : t('Display Name is Required') }} name='displayName' label={t('Display Name')} register={register} placeholder={t('Enter Display Name')} type="text" readOnly={newNode?.isVacant} value={!newNode?.isVacant ? newNode?.displayName : 'Vacant'} onValueChange={handleAddFieldsChange} disabled={loading} />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            {/* <Input errors={errors} control={control} required rules={{ required: t('Designation is Required') }} name='designation' label={t('Designation')} register={register} placeholder={t('Enter Designation')} type="text" value={newNode?.designation} onValueChange={handleAddFieldsChange} /> */}
                            <SearchableSelectInput
                                errors={errors} control={control}
                                required rules={{ required: t('Designation is Required') }}
                                name="designation" label={t('Designation')} placeholder="Enter Designation"
                                value={newNode?.designation || ''}
                                options={desByOrgId?.map((data) => {
                                    return ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status })
                                })}
                                onValueChange={(value) => { handleAddFieldsChange(value, 'designation') }} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='level' label={t('Level')} register={register} placeholder={t('Enter Level')} type="number" value={currentNode?.level ? currentNode?.level + 1 : 1} disabled={loading} />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <SearchableSelectInput
                                errors={errors} control={control}
                                required rules={{ required: t('Department is Required') }}
                                name="department" label={t('Department')} placeholder="Enter Department"
                                value={newNode?.department || ''}
                                options={depByOrgId?.map((data) => {
                                    return ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status })
                                })}
                                onValueChange={(value) => { handleAddFieldsChange(value, 'department') }} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} setError={setError} clearErrors={clearErrors} control={control} required={!newNode?.isVacant}
                                rules={{
                                    validate: (value) => {
                                        const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                        if (!value && !newNode.isVacant) {
                                            return t('Email is required')
                                        } else if (!regexEmail.test(value) && !newNode.isVacant) {
                                            return t('Enter a valid email')
                                        }
                                    },
                                    required: newNode?.isVacant ? false : t('Email ID is required')
                                }}
                                name='emailId' label={t('Email ID')} register={register} placeholder={t('Enter Email ID')} type="text" value={!newNode?.isVacant ? newNode?.emailId : ''} onValueChange={handleAddFieldsChange} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            {/* <Input errors={errors} control={control} required={!newNode?.isVacant} setError={setError} clearErrors={clearErrors}
                                rules={{
                                    validate: (value) => {
                                        const regexPhone = /^[0-9]{10}$/
                                        if (!value && !newNode?.isVacant) { return 'Phone number is required' } else if (!regexPhone.test(value) && !newNode?.isVacant) { return 'Phone number must be 10 digits' }
                                    },
                                    required: !newNode?.isVacant ? 'Phone number is required' : false
                                }}
                                name='phoneNumber' label={t('Phone Number')} register={register} placeholder={t('Enter Phone Number')} type="number" setValue={setValue} value={!newNode?.isVacant ? newNode?.phoneNumber : ''} onValueChange={handleAddFieldsChange} /> */}
                            <PhoneNumber
                                name='phoneNumber'
                                label={t('Phone Number')}
                                placeholder={t('Enter phone number')}
                                required={!newNode?.isVacant}
                                // value={!newNode?.isVacant ? newNode?.phoneNumber : ''}
                                value={!newNode?.isVacant ? newNode?.phoneNumber ? `${newNode?.phoneCode || ''}${newNode?.phoneNumber}` : '' : ''}
                                rules={{
                                    validate: (value) => {
                                        if (!value && !newNode?.isVacant) { return 'Phone number is required' }
                                        const trimmedValue = value.startsWith('+91') ? value.slice(3).replace(/\s+/g, '').trim() : value.replace(/\s+/g, '').trim()
                                        const regexPhone = /^[0-9]{10}$/
                                        if (!regexPhone.test(trimmedValue) && !newNode?.isVacant) { return 'Phone Number must be 10 digits' }
                                    },
                                    required: !newNode?.isVacant ? 'Phone number is required' : false
                                }}
                                register={register} control={control} errors={errors} setError={setError} clearErrors={clearErrors} setValue={setValue}
                                onValueChange={handleAddFieldsChange}
                                disabled={loading}
                            />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <MultiSelectInput required rules={{ validate: value => value.length > 0 || 'Role is required' }} label={t('Role')} control={control} errors={errors} name="role" placeholder={t('Select Role')} value={newNode?.role} options={roleData?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                onValueChange={(value) => {
                                    handleAddFieldsChange(value, 'role')
                                    setValue('role', value, { shouldValidate: true })
                                }} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '5%' }}>
                            <DatePickerInput
                                errors={errors}
                                control={control}
                                resetTrigger={resetTrigger}
                                required
                                rules={{ required: t('From date is required') }}
                                name='fromDate'
                                label={t('Effective From')}
                                register={register}
                                type="text"
                                value={newNode?.fromDate || ''}
                                onValueChange={handleAddFieldsChange}
                                maxDate={fromMaxDate}
                                disabled={loading}
                            />
                        </div>
                        {/* <div style={{ width: '100%', marginBottom: '5%' }}>
                            <DatePickerInput
                                errors={errors}
                                control={control}
                                resetTrigger={resetTrigger}
                                required
                                disabled={newNode?.isVacant || newNode?.atPresent}
                                rules={newNode?.atPresent ? {} : { required: t('To date is required') }}
                                name='toDate'
                                label={t('To')}
                                register={register}
                                type="text"
                                value={newNode?.atPresent ? '' : newNode?.toDate }
                                lableComponent={lableComponent}
                                onValueChange={handleAddFieldsChange}
                                minDate={newNode?.fromDate || ''}
                                maxDate={fromMaxDate}
                            />
                        </div> */}
                    </div>
                    {currentNode?.designation && <h2 style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', padding: '10px 0px 10px 15px', marginTop: '3px' }} className='border-t-2'>{t('Reports To')}</h2>}
                    {currentNode?.designation && <div className="grid grid-cols-3 gap-4 mt-2 px-4">
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='Department' label={t('Department')} register={register} placeholder="Enter Department" type="text"
                                value={typeof currentNode?.department === 'number' ? depByOrgId?.find(dep => dep.id === currentNode?.department)?.name || '' : currentNode?.department || ''} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='Designation' label={t('Designation')} register={register} placeholder="Enter Designation" type="text"
                                value={typeof currentNode?.designation === 'number' ? desByOrgId?.find(des => des.id === currentNode?.designation)?.name || '' : currentNode?.designation || ''} disabled={loading}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='Name' label={t('Name')} register={register} placeholder="Enter Name" type="text" value={currentNode?.displayName || ''} disabled={loading}/>
                        </div>
                    </div>}

                </div>
            </div>
            <div className="flex justify-end space-x-4 h-[12%] items-center pr-8">
                <Button variant='outline' style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    disabled={loading}
                    onClick={() => handleCancelClose()}>{t('Cancel')} </Button>
                <Button onClick={() => { handleSubmit(onSubmit)() }} disabled={isSubmitting || isLoading || loading}>
                    {loading ? t('Adding...') : t('Add')}
                </Button>
            </div>
        </Box>
    )

    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 1.8, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={addState.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                {list('right')}
            </SwipeableDrawer>
        </div>
    )
}

AddNodeDrawer.propTypes = {
    setnewNode: PropTypes.func,
    currentNode: PropTypes.object,
    newNode: PropTypes.object,
    setAddState: PropTypes.func,
    addState: PropTypes.func,
    onAdd: PropTypes.func,
    childNodeCount: PropTypes.any,
    nodes: PropTypes.array,
    loading: PropTypes.bool,
    setLoading: PropTypes.bool
}

export default AddNodeDrawer
